// extracted by mini-css-extract-plugin
export default {"container":"DesktopNav--container--c+Nru","item":"DesktopNav--item--fO4GZ","loginBtn":"DesktopNav--loginBtn--mOl73","signupBtn":"DesktopNav--signupBtn--eUI6+"};